import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';
import Logo from '../assets/logo-asifc.png'

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [show, setShow] = useState(false);
  const location = useLocation();



  const controlNav = () => {
    if (window.scrollY > 250) {
      setShow(true)
    }else{
      setShow(false)
    }
    
  }

  useEffect(() => {
    window.addEventListener('scroll', controlNav)
    return () => {
      window.removeEventListener('scroll', controlNav)
    }
  }, [])



  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle('menu-open');
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`header-active ${show && 'header-hidden'}`}>

            <div className='wrapper-header'>

         
             {/* Logo */}
        <Link to="/" className="logo" onClick={closeMenu}>
          <div className="logo-text">
            <img src={Logo} className='logo-main'/>
          </div>
        </Link>


      <div  className="header-container">

        {/* Navigation */}
        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link 
                to="/" 
               className='nav-link'
                onClick={closeMenu}
              >
                Accueil
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/actualites" 
                className='nav-link'
                onClick={closeMenu}
              >
                Actualités
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/permanence-numerique" 
                className='nav-link'
                onClick={closeMenu}
              >
                Permanence Numérique
              </Link>
            </li>
            <li className="nav-item">
              <a 
                href="/#objectifs" 
                className="nav-link"
                onClick={closeMenu}
              >
                Qui sommes-nous ?
              </a>
            </li>
            <li className="nav-item">
              <Link 
                to="/benevole" 
                className={`nav-link nav-cta ${isActive('/benevole') ? 'active' : ''}`}
                onClick={closeMenu}
              >
                Devenir Bénévole
              </Link>
            </li>
          </ul>
        </nav>

   
      </div>

           {/* Menu burger */}
        <button 
          className={`menu-burger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Overlay */}
        {isMenuOpen && (
          <div className="menu-overlay" onClick={closeMenu}></div>
        )}

           </div>
    </header>
  );
}

export default Header;